
export default function Hero() {
  const scrollToProducts = () => {
    const productsSection = document.getElementById('productos');
    if (productsSection) {
      productsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/be0d190346a214905d4e5dc6b71fb1e4.jpg')`
        }}
      >
        <div className="absolute inset-0 bg-black/60"></div>
      </div>

      {/* Animated particles */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 left-1/4 w-2 h-2 bg-[#C6A45C] rounded-full animate-ping opacity-70"></div>
        <div className="absolute top-3/4 right-1/4 w-1 h-1 bg-[#C6A45C] rounded-full animate-pulse opacity-50"></div>
        <div className="absolute top-1/2 left-3/4 w-1.5 h-1.5 bg-[#C6A45C] rounded-full animate-bounce opacity-60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto">
        <div className="mb-6 opacity-0 animate-[fadeInUp_1s_ease-out_0.5s_forwards]">
          <span className="inline-block bg-[#C6A45C] text-black px-4 py-2 text-sm font-light uppercase tracking-wider rounded-full" style={{ fontFamily: '"Lato", sans-serif' }}>
            Colección Exclusiva
          </span>
        </div>
        
        <h1 
          className="text-4xl md:text-5xl lg:text-6xl font-thin text-white mb-6 leading-tight opacity-0 animate-[fadeInUp_1s_ease-out_0.7s_forwards]"
          style={{ fontFamily: '"Lato", sans-serif' }}
        >
          ISLA Collection
        </h1>
        
        <div className="w-24 h-0.5 bg-[#C6A45C] mx-auto mb-6 opacity-0 animate-[fadeInUp_1s_ease-out_0.9s_forwards]"></div>
        
        <p className="text-lg md:text-xl text-gray-300 mb-8 font-thin leading-relaxed opacity-0 animate-[fadeInUp_1s_ease-out_1.1s_forwards]" style={{ fontFamily: '"Lato", sans-serif' }}>
          Una selección privada de carteras de lujo importadas
        </p>
        
        <div className="opacity-0 animate-[fadeInUp_1s_ease-out_1.3s_forwards]">
          <button 
            onClick={scrollToProducts}
            className="group bg-transparent border-2 border-[#C6A45C] text-[#C6A45C] px-8 py-4 text-sm font-light uppercase tracking-wider hover:bg-[#C6A45C] hover:text-black transition-all duration-500 transform hover:scale-105 whitespace-nowrap flex items-center gap-3 mx-auto cursor-pointer relative overflow-hidden"
            style={{ fontFamily: '"Lato", sans-serif' }}
          >
            <span className="relative z-10">Descubrir más</span>
            <i className="ri-arrow-right-line text-lg relative z-10 group-hover:translate-x-1 transition-transform duration-300"></i>
            <div className="absolute inset-0 bg-[#C6A45C] transform -translate-x-full group-hover:translate-x-0 transition-transform duration-500"></div>
          </button>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce opacity-0 animate-[fadeIn_1s_ease-out_2s_forwards]">
        <div className="flex flex-col items-center space-y-2">
          <span className="text-white text-xs font-thin uppercase tracking-wider" style={{ fontFamily: '"Lato", sans-serif' }}>Scroll</span>
          <div className="w-px h-8 bg-[#C6A45C]"></div>
          <i className="ri-arrow-down-line text-[#C6A45C] text-lg"></i>
        </div>
      </div>
    </section>
  );
}
